import React from 'react';

import { components } from 'react-select';

export function MultiValueContainer ({ children, ...props }) {
  const { selectProps } = props;
  let [values, input] = children;

  if (Array.isArray(values)) {
    values = selectProps?.value.map(x => x.label).join(', ');
  }

  return (
    <components.ValueContainer {...props}>
      <div
        style={{
          maxWidth: '300px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        {values}
      </div>
      {input}
    </components.ValueContainer>
  );
};
